(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bijon-password"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initialize(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    const mediaHost = root.querySelector('[data-desktop-media]');
    const videoTemplate = root.querySelector('[data-desktop-video]');
    function syncMedia() {
      if (!mediaHost || !videoTemplate) return;
      if (mobile.matches) {
        const video = mediaHost.querySelector('video');
        if (video) { video.pause(); video.removeAttribute('src'); video.querySelectorAll('source').forEach(function(source) { source.removeAttribute('src'); }); video.load(); }
        mediaHost.replaceChildren();
      } else if (!mediaHost.querySelector('video')) {
        mediaHost.appendChild(videoTemplate.content.cloneNode(true));
        const video = mediaHost.querySelector('video');
        if (video) { const play = video.play(); if (play) play.catch(function() {}); }
      }
    }
    syncMedia();
    mobile.addEventListener('change', syncMedia);
    function cleanup(event) {
      if (event.target.contains(root)) { clearInterval(timer); mobile.removeEventListener('change', syncMedia); document.removeEventListener('shopify:section:unload', cleanup); }
    }
    document.addEventListener('shopify:section:unload', cleanup);
    const countdown = root.querySelector('[data-countdown]');
    const ended = root.querySelector('[data-countdown-ended]');
    const deadline = root.dataset.deadline.trim();
    const target = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(deadline) ? Date.parse(deadline) : NaN;
    let timer;
    function tick() {
      if (!root.isConnected) { clearInterval(timer); return; }
      const seconds = Math.max(0, Math.ceil((target - Date.now()) / 1000));
      if (seconds === 0) { countdown.hidden = true; ended.hidden = false; clearInterval(timer); return; }
      const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      Object.keys(values).forEach(function(unit) { root.querySelector('[data-unit="' + unit + '"]').textContent = String(values[unit]).padStart(2, '0'); });
      countdown.hidden = false;
    }
    if (countdown && Number.isFinite(target)) { timer = setInterval(tick, 1000); tick(); }
    else if (countdown) { const invalid = root.querySelector('[data-countdown-invalid]'); if (invalid) invalid.hidden = false; }
    root.querySelector('[data-password-focus]').addEventListener('click', function(event) { event.preventDefault(); const input = root.querySelector('input[name="password"]'); input.scrollIntoView({block:'center',behavior:'smooth'}); input.focus({preventScroll:true}); });
  }
  function initializeAll() { document.querySelectorAll('[data-bijon-password]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll); else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();

  } catch(e) { console.error(e); }
})();
})();
